import React from 'react';
import { Routes, Route } from "react-router-dom";
import Research from './Components/pages/Research';
import Login from './Components/pages/Login';
import NotFound from './Components/pages/NotFound';
import ProtectedRoutes from './Components/routing/ProtectedRoutes';
import AdminRoutes from './Components/routing/AdminRoutes';
import './App.css';
import CitysearchFc from './Components/pages/SearchFc';
import Home from './Components/pages/Home';
import FibreConnect from './Components/pages/FibreConnect';
import ControlPanel from './Components/pages/ControlPanel';
import TotalResearch from './Components/pages/TotalResearch';
import UniData from './Components/pages/UniData';

function App() {
  return (
    <div>
      <Routes>
          <Route exact path='/' element={<Login/>}/>
          <Route element={<ProtectedRoutes/>}>
            <Route exact path='/home' element={<Home />}/>
            <Route exact path='/research' element={<Research />}/>
            <Route exact path='/researchfc' element={<CitysearchFc/>}/>
            <Route exact path='/fibreconnect' element={<FibreConnect />}/>
            <Route exact path='/unidata' element={<UniData />}/>
            <Route exact path='/total' element={<TotalResearch />}/>
          </Route>
          <Route element={<AdminRoutes/>}>
            <Route exact path='/cp' element={<ControlPanel />}/>
          </Route>

          <Route path='*' element={<NotFound />} />
      </Routes>
    <div className='bg'></div>
  </div>
);
}

export default App;
